import axios from "axios";
import { store } from "@/store";
// import { authenticationService } from "@/_services";
// const tenantId =
//   authenticationService.currentUserValue == null
//     ? null
//     : authenticationService.currentUserValue.tenantId;
const Api = axios.create({
  //baseURL: "http://localhost:5283",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

Api.interceptors.request.use((c) => {
  c.baseURL = process.env.VUE_APP_API_SERVER;
  store.commit("ADD_PENDING", c.url);
  return c;
});

Api.interceptors.response.use(
  (c) => {
    store.commit("REMOVE_PENDING", c.request.responseURL);
    return c;
  },
  function (error) {
    store.commit("REMOVE_PENDING", error.request.responseURL);

    if (401 === error.response.status) {
      // window.location = "/sign-in";
    } else {
      return Promise.reject(error);
    }
  }
);

export default Api;
